import React from 'react';
import PropTypes from 'prop-types';

import {
  ChartProbabilityPlotIcon,
  ChartBoxIcon,
  ChartDotIcon
} from 'react-magma-icons';

import IconSvg from 'components/IconSvg';

import {
  TabsContainer,
  Tabs,
  Tab,
  TabPanel,
  TabPanelsContainer
} from 'react-magma-dom';

const RightPaneComponent = props => (
  <div className="content-item">
    <div className="flex space-between mb-30">
      <TabsContainer className="tab-container" activeIndex={props.activeIndex}>
        <Tabs onChange={props.handleTabChange}>
          <Tab className="tab-button">
            <IconSvg iconName="HISTOGRAM" fill="currentColor" size={props.iconsSize} />
            Histogram
          </Tab>
          <Tab className="tab-button">
            <ChartBoxIcon size={props.iconsSize} />
            Box Plot
          </Tab>
          <Tab className="tab-button">
            <ChartDotIcon size={props.iconsSize} />
            Dot Plot
          </Tab>
          <Tab className="tab-button">
            <IconSvg iconName="SCATTER_PLOT" fill="currentColor" size={props.iconsSize} />
            Scatter Plot
          </Tab>
          <Tab className="tab-button">
            <IconSvg iconName="BAR_CHART" fill="currentColor" size={props.iconsSize} />
            Bar Chart
          </Tab>
          <Tab className="tab-button">
            <IconSvg iconName="PIE_CHART" fill="currentColor" size={props.iconsSize} />
            Pie Chart
          </Tab>
          <Tab className="tab-button">
            <ChartProbabilityPlotIcon size={props.iconsSize} />
            Probability Plot
          </Tab>
        </Tabs>

        <TabPanelsContainer className="tabPanelsContainer">
          <TabPanel className="tab-panel">{props.renderHistogram()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderBoxPlot()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderDotPlot()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderScatterPlot()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderBarChart()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderPieChart()}</TabPanel>
          <TabPanel className="tab-panel">{props.renderProbabilityPlot()}</TabPanel>
        </TabPanelsContainer>
      </TabsContainer>
    </div>
  </div>
);

RightPaneComponent.propTypes = {
  renderBoxPlot: PropTypes.func.isRequired,
  renderHistogram: PropTypes.func.isRequired,
  renderDotPlot: PropTypes.func.isRequired,
  renderScatterPlot: PropTypes.func.isRequired,
  renderBarChart: PropTypes.func.isRequired,
  renderPieChart: PropTypes.func.isRequired,
  renderProbabilityPlot: PropTypes.func.isRequired,
  iconsSize: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired
};

export default RightPaneComponent;
